export default function ($translate) {
    return {
        KEYS: {
            TRAINING: 'TRAINING',
            CONFERENCE: 'CONFERENCE',
            ONLINE_COURSE: 'ONLINE_COURSE'
        },
        LABELS: {
            TRAINING: $translate.instant('course.external.participation.training'),
            CONFERENCE: $translate.instant('course.external.participation.conference'),
            ONLINE_COURSE: $translate.instant('course.external.participation.online course')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/course/externalParticipationTrainingType/index.js